<nav class="breadcrumb-container">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <ng-container *ngIf="!last">
      <a class="link" [routerLink]="breadcrumb.url">
        <span class="label">{{ breadcrumb.label }}</span>
      </a>
      <span class="gt-sign">&gt;</span>
    </ng-container>
    <ng-container *ngIf="last">
      <span class="last label">{{ breadcrumb.label }}</span>
    </ng-container>
  </ng-container>
</nav>
